import _ from 'lodash';
import {PERSON_ALERT_MUTATION_TEMPLATE} from './templates/mutationTemplates';
import gatewayFetch from '../../appModules/utilities/gatewayFetch';
import {
  mutationRequest,
  mutatePersonAlertSuccess,
  mutatePersonAlertFailure,
} from './actions';

/**
 * Posts a person alert through the gateway to the person service
 * @method mutatePersonAlert
 * @param  {object}   mutationParams parameters to add to the query template
 * @return {function} returns the function to make the post
 */
export function mutatePersonAlert(mutationParams) {
  return dispatch => {
    dispatch(mutationRequest());
    if (!_.isEmpty(mutationParams)) {
      const query = PERSON_ALERT_MUTATION_TEMPLATE(mutationParams);

      return gatewayFetch(query, 'mutation')
        .then(data => dispatch(mutatePersonAlertSuccess(data)))
        .catch(reason => dispatch(mutatePersonAlertFailure(reason)));
    }

    dispatch(mutatePersonAlertFailure('no post parameters present'));
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/personAlertHelper.js